import { render, staticRenderFns } from "./VisitLocationFilters.vue?vue&type=template&id=6c371a88&"
import script from "./VisitLocationFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VisitLocationFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c371a88')) {
      api.createRecord('6c371a88', component.options)
    } else {
      api.reload('6c371a88', component.options)
    }
    module.hot.accept("./VisitLocationFilters.vue?vue&type=template&id=6c371a88&", function () {
      api.rerender('6c371a88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/VisitLocationFilters/VisitLocationFilters.vue"
export default component.exports